module.exports = __webpack_public_path__ + "img/yuzhong.c2155c3b.jpg";